module.exports = __webpack_public_path__ + "img/conversations-empty-state-no-results.4054d306.svg";